import { SegmentationRule } from '@salecycle/experimental/Modal/SegmentationModal';
import { ResponseSegmentationRules } from 'sections/onsite-campaigns/types';

const valueToType = (value: string) => {
  switch (value) {
    case 'true':
    case 'false':
      return JSON.parse(value);
    default:
      return value;
  }
};

/**
 * Removes the empty rules by checking if there are any ORs. If there are no ORs, then the rules
 * are filtered out.
 *
 * @param AND
 * @returns
 */
const removeEmptyRules = AND => AND.find(OR => OR) !== undefined;

/**
 * Converts the segmentation configuration values into a structure that is valid for either the state of the
 * campaign request.
 *
 * Any rule arrays that are empty are stripped out.
 *
 * @param rules Rules to convert
 * @param forRequest If true it will convert the configuration value into a format that is valid for the Campaign request.
 * @returns converted segmentation list.
 */
export const convertSegmentRuleValues = (
  rules: ResponseSegmentationRules | undefined,
  forRequest = false,
): SegmentationRule<any, any, any>[][] | undefined => {
  return rules?.filter(removeEmptyRules).map(AND =>
    AND.map(OR => ({
      ...OR,
      configuration: {
        ...OR.configuration,
        value: forRequest ? valueToType(OR.configuration?.value) : `${OR.configuration?.value}`,
      },
    })),
  );
};
